export default __webpack_public_path__ + "5e53d6a09c5cf43b7d0d6afdcbb55132.svg";